import { routes } from './entities.routes';
import SusEneListEntitiesController from "./directory/directory.controller";
import SusEneDetailsEntitiesController from "./details/details.controller";
export default angular.module('app.susene.entities', [])
    .config(routes)
    .controller('SusEneListEntitiesController', SusEneListEntitiesController)
    .controller('SusEneDetailsEntitiesController', SusEneDetailsEntitiesController)
    .name;
